import Immutable, { Map, fromJS } from 'immutable';
import {
  SET_PROJECT,
  SET_PROJECT_UNDOABLE,
  SPREADS_ADDED,
  setProject,
  setProjectUndoable,
  getDefaultSelectedPage,
  getDefaultSelectedPageItem,
} from './project';
import { SPREAD_UPDATE_PAGE_THUMB } from './sections';
import {
  SET_BACKGROUND_IMAGE,
  SET_BACKGROUND_COLOR,
  SET_BACKGROUND_COLOR_UNDOABLE,
  SET_BACKGROUND_PATTERN,
} from './backgrounds';
import { fork, select, put, takeLatest, takeEvery } from 'redux-saga/effects';
import {
  PAGE_UPDATED,
  PAGES_UPDATED,
} from '../sagas/ReturnedChangesetProcessor';
import * as Selectors from '../reducers/selectors';
import * as Changesets from './changesets';
import { insertPageItems, updatePageItemsNoUndo } from './pageItems';
import { setLoadedImagesSection } from './loadedImages';
import {
  ADD_PAGE_ITEMS,
  ADD_PAGE_ITEMS_BY_OTHER,
  REMOVE_PAGE_ITEMS,
} from './pageItems';
import { getProject, getImagesMetadata } from '../utils/zoomServices';
import { showLeftoverCaptionsModal } from './modals';
import {
  renderCanvasFromStore,
  keepSelectedTab,
  setLeftPageZoom,
  exitPreviewMode,
} from './navigation';
import PicabooConstants from '../common/PicabooConstants';
import {
  clearSelection,
  selectPages,
  selectPageItems,
  setApplyLayoutCallback,
} from './selection';
import { requestThumbnail, watchThumbRequest } from '../utils/thumbnailService';
import { createBrowserHistory } from 'history';
const browserHistory = createBrowserHistory();
import { wrapSelector } from '../reducers/selectors';
import { getParameterByName } from '../utils/general';
import { isMobile } from '../components/PicabooResponsive';
import { EnvUtils } from '../utils/EnvUtils';
import { obfuscateProjectId } from '../utils/projectId';

/**
 *  action constants
 */
export const UPDATE_PAGE = 'pages/UPDATE_PAGE';
export const UPDATE_PAGES = 'pages/UPDATE_PAGES';
export const REPLACE_PAGE = 'pages/REPLACE_PAGE';
export const CONVERT_SPREAD_PAGES = 'pages/CONVERT_SPREAD_PAGES';

const REORDER_ITEM = 'page/REORDER_ITEM';
export const MOVE_TO_BOTTOM = 'page/MOVE_BOTTOM';
export const MOVE_DOWN = 'pages/MOVE_DOWN';
export const MOVE_UP = 'pages/MOVE_UP';
export const MOVE_TO_TOP = 'pages/MOVE_TOP';
export const LEFT = 'pages/LEFT';
export const RIGHT = 'pages/RIGHT';

export const UPDATE_PAGE_THUMB = 'page/UPDATE_PAGE_THUMB';
export const PAGE_THUMB_UPDATED = 'page/PAGE_THUMB_UPDATED';
export const GENERATE_THUMB = 'page/GENERATE_THUMB';
export const GENERATE_THUMBS = 'page/GENERATE_THUMBS';
export const SET_GENERATE_THUMB_COUNT = 'page/SET_GENERATE_THUMB_COUNT';
export const GENERATE_THUMB_COMPLETE = 'page/GENERATE_THUMB_COMPLETE';
export const STOP_THUMBS = 'STOP_THUMBS';

const PREVIOUS_SPREAD = 'pages/PREVIOUS_SPREAD';
const NEXT_SPREAD = 'pages/NEXT_SPREAD';
const GO_TO_SPREAD = 'pages/GO_TO_SPREAD';
const RELOAD_SPREAD = 'pages/RELOAD_SPREAD';
export const RELOAD_SPREAD_UNDOABLE = 'pages/RELOAD_SPREAD_UNDOABLE';
export const REORDER_SECTION_SPREADS = 'pages/REORDER_SECTION_SPREADS';
export const DELETE_SPREAD = 'pages/DELETE_SPREAD';
export const DUPLICATE_SPREAD = 'pages/DUPLICATE_SPREAD';
export const ADD_SPREAD = 'pages/ADD_SPREAD';
export const APPLY_FILTER_TO_ALL_PAGES = 'pages/APPLY_FILTER_TO_ALL_PAGES';
export const APPLY_DROP_SHADOW_TO_ALL_PAGES =
  'pages/APPLY_DROP_SHADOW_TO_ALL_PAGES';
export const PAGE_LAST_UPDATE_CHANGED = 'pages/PAGE_LAST_UPDATE_CHANGED';

/**
 *  reducers
 */

const reducer = function pages(state = new Map(), action) {
  // const newState = {...state};
  let newState;
  switch (action.type) {
    case SET_PROJECT_UNDOABLE:
    case SET_PROJECT:
      let pages =
        action.project.pages !== undefined
          ? fromJS(action.project.pages)
          : state;
      return pages;
    case PAGE_LAST_UPDATE_CHANGED:
      if (!state.get(action.page.pageID)) {
        return state;
      }
      state = state.setIn(
        [action.page.pageID, 'dateLastModified'],
        action.page.pageLastUpdated,
      );
      return state;
    case UPDATE_PAGES:
      return fromJS(action.pages);

    case UPDATE_PAGE:
      if (!state.get(action.page.id)) {
        return state;
      }
      return state.set(action.page.id, fromJS(action.page));
    case PAGE_THUMB_UPDATED:
    case UPDATE_PAGE_THUMB:
      if (state.get(action.pageID) != undefined) {
        let newPageState = fromJS(
          Object.assign({}, state.get(action.pageID).toJS(), {
            thumbnailURL: action.thumbURL,
          }),
        );
        return state.set(action.pageID, newPageState);
      }

      return state;
    case REPLACE_PAGE:
      if (!state.get(action.page.id)) {
        return state;
      }
      return state.set(action.page.id, fromJS(action.page));
    case SET_BACKGROUND_COLOR_UNDOABLE:
    case SET_BACKGROUND_COLOR:
      // action.pages.map(p=>{
      //     newState[p.id.toUpperCase()] = Object.assign({}, newState[p.id.toUpperCase()], {background: {graphicItem: null, color: parseInt(action.color.replace('#', ''), 16) }})
      // });
      newState = state;
      action.pages.map((p) => {
        if (state.get(p.get('id'))) {
          const currentPattern = state
            .get(p.get('id'))
            .getIn(['background', 'pattern']);
          newState = newState.set(
            p.get('id'),
            fromJS(
              Object.assign({}, state.get(p.get('id')).toJS(), {
                background: {
                  graphicItem: null,
                  pattern: currentPattern,
                  color:
                    !isNaN(parseFloat(action.color)) && isFinite(action.color)
                      ? action.color
                      : parseInt(action.color.replace('#', ''), 16),
                },
              }),
            ),
          );
        }
      });
      return newState;
    case SET_BACKGROUND_IMAGE:
      newState = state;
      action.pages.map((p) => {
        if (state.get(p.get('id'))) {
          newState = newState.set(
            p.get('id'),
            fromJS(
              Object.assign({}, state.get(p.get('id')).toJS(), {
                background: { graphicItem: action.pageItem.id },
              }),
            ),
          );
        }
        // newState = newState.set(p.get('id').toUpperCase(), state.get(p.get('id').setIn(['background', 'graphicItem'], action.imageID.toUpperCase())))
      });
      return newState;
    case SET_BACKGROUND_PATTERN:
      newState = state;
      action.pages.map((p) => {
        if (state.get(p.get('id'))) {
          const currentColor = state
            .get(p.get('id'))
            .getIn(['background', 'color']);
          newState = newState.set(
            p.get('id'),
            fromJS(
              Object.assign({}, state.get(p.get('id')).toJS(), {
                background: {
                  graphicItem: null,
                  color: currentColor ?? 16777215,
                  pattern: action.pattern,
                },
              }),
            ),
          );
        }
      });
      return newState;
    case ADD_PAGE_ITEMS:
    case ADD_PAGE_ITEMS_BY_OTHER:
      if (!state.get(action.page)) {
        return state;
      }
      newState = state;
      for (let item of action.pageItems) {
        if (!state.getIn([action.page, 'pageItems']).includes(item.get('id'))) {
          newState = newState.updateIn([action.page, 'pageItems'], (items) =>
            items.push(item.get('id')),
          );
        }
      }
      return newState;
    case REMOVE_PAGE_ITEMS:
      if (!state.get(action.page)) {
        return state;
      }
      newState = state;

      for (let pi of action.items) {
        newState = newState.updateIn([action.page, 'pageItems'], (items) =>
          items.filter((item) => item != pi),
        );
      }
      //let newState = state.updateIn([action.page, 'pageItems'], (items) => items.filter(item => item != action.item));

      return newState;
    case MOVE_DOWN:
      if (!state.get(action.item.get('pageID'))) {
        return state;
      }
      return state.updateIn(
        [action.item.get('pageID'), 'pageItems'],
        (items) => {
          let index = items.indexOf(action.item.get('id'));
          if (index > 0) {
            let end = items.slice(index + 1);
            return items
              .slice(0, index - 1)
              .concat(items.get(index))
              .concat(items.get(index - 1))
              .concat(end);
          } else {
            return items;
          }
        },
      );
    case MOVE_TO_BOTTOM:
      if (!state.get(action.item.get('pageID'))) {
        return state;
      }
      return state.updateIn(
        [action.item.get('pageID'), 'pageItems'],
        (items) => {
          let index = items.indexOf(action.item.get('id'));
          if (index > 0) {
            return items.remove(index).insert(0, items.get(index));
          } else {
            return items;
          }
        },
      );
    case MOVE_UP:
      if (!state.get(action.item.get('pageID'))) {
        return state;
      }
      return state.updateIn(
        [action.item.get('pageID'), 'pageItems'],
        (items) => {
          let index = items.indexOf(action.item.get('id'));
          if (index >= 0 && index < items.size - 1) {
            return items.remove(index).insert(index + 1, items.get(index));
          } else {
            return items;
          }
        },
      );
    case MOVE_TO_TOP:
      if (!state.get(action.item.get('pageID'))) {
        return state;
      }
      return state.updateIn(
        [action.item.get('pageID'), 'pageItems'],
        (items) => {
          let index = items.indexOf(action.item.get('id'));
          if ((index) => 0 && index < items.size - 1) {
            return items.remove(index).push(items.get(index));
          } else {
            return items;
          }
        },
      );
    case SPREAD_UPDATE_PAGE_THUMB:
      if (!state.get(action.pageId)) {
        return state;
      }
      if (state.get(action.pageId)) {
        let newState = state.setIn(
          [action.pageId, 'thumbnailURL'],
          action.thumbURL,
        ); //.setIn([action.pageId, 'dateLastModified'], Date.now())
        return newState;
      } else {
        return state;
      }
  }

  return state;
};

//noinspection JSUnusedGlobalSymbols
/**
 *  actions
 */

export function generateThumb(
  pageID,
  spreadID,
  sectionID,
  isProjectThumb = false,
  retryOnFail = false,
  cropCover = false,
  isBlank = false,
  pageRatio = 0,
) {
  return {
    type: GENERATE_THUMB,
    pageID,
    spreadID,
    sectionID,
    isProjectThumb,
    retryOnFail,
    cropCover,
    isBlank,
    pageRatio,
  };
}

export function generateThumbs(pages) {
  return {
    type: GENERATE_THUMBS,
    pages,
  };
}

export function updatePageThumb(pageID, thumbURL, sectionID) {
  return {
    type: UPDATE_PAGE_THUMB,
    pageID,
    sectionID,
    thumbURL,
  };
}

export function stopThumbs() {
  return {
    type: STOP_THUMBS,
  };
}

export const DIRECTIONS = {
  TOP: MOVE_TO_TOP,
  UP: MOVE_UP,
  DOWN: MOVE_DOWN,
  BOTTOM: MOVE_TO_BOTTOM,
  LEFT: LEFT,
  RIGHT: RIGHT,
};

export function reorderItem(item, direction) {
  return {
    type: REORDER_ITEM,
    item,
    direction,
  };
}

export function updatePage(page) {
  return {
    type: UPDATE_PAGE,
    page,
  };
}

export function updatePageLastUpdate(page) {
  return {
    type: PAGE_LAST_UPDATE_CHANGED,
    page,
  };
}

export function updatePages(pages) {
  return {
    type: UPDATE_PAGES,
    pages,
  };
}

export function replacePage(page, pageItems) {
  return {
    type: REPLACE_PAGE,
    page,
    pageItems,
  };
}

export function whileApplyingChanges(action) {
  action.APPLYING_CHANGES = true;
  return action;
}

export function deleteSpread(spreadID) {
  return {
    type: DELETE_SPREAD,
    spreadID,
  };
}

export function duplicateSpread(spreadID) {
  return {
    type: DUPLICATE_SPREAD,
    spreadID,
  };
}

export function addSpread(sectionID, spreadID) {
  return {
    type: ADD_SPREAD,
    sectionID,
    after: spreadID,
  };
}

export function nextSpread() {
  return {
    type: NEXT_SPREAD,
  };
}

export function previousSpread() {
  return {
    type: PREVIOUS_SPREAD,
  };
}

export function gotoSpread(spread, exitPreviewMode = false) {
  return {
    type: GO_TO_SPREAD,
    spread,
    exitPreviewMode,
  };
}

export function reloadSpread() {
  return {
    type: RELOAD_SPREAD,
  };
}

export function reorderSectionSpreads(sectionID, spreads) {
  return {
    type: REORDER_SECTION_SPREADS,
    sectionID,
    spreads,
  };
}

export function reloadSpreadUndoable() {
  return {
    type: RELOAD_SPREAD_UNDOABLE,
  };
}

export function convertSpreadPages(background = null, callback) {
  return {
    type: CONVERT_SPREAD_PAGES,
    background,
    callback,
  };
}

export function applyFilterToAllPages(pageID, pageItemID, filter) {
  return {
    type: APPLY_FILTER_TO_ALL_PAGES,
    pageID,
    pageItemID,
    filter,
  };
}

export function applyDropShadowToAllPages(pageID, pageItemID) {
  return {
    type: APPLY_DROP_SHADOW_TO_ALL_PAGES,
    pageID,
    pageItemID,
  };
}

/**
 * Sagas
 */

/**
 * Called from updated changeset push to update local page info
 * @param action
 */
function* reorderItemHandler(action) {
  try {
    yield put({ type: action.direction, item: action.item });
    yield put(Changesets.updatePages(yield select(Selectors.selectedPages)));
  } catch (error) {
    console.error('reorder Item error', error);
  }
}

function* spreadsAddedHandler(action) {
  for (var s = 0; s < action.spreads.length; ++s) {
    let spread = action.spreads[s];
    for (var p = 0; p < spread.pages.length; ++p) {
      let page = spread.pages[p];
      yield put(generateThumb(page.pageID, spread.id, action.sectionID));
    }
  }
}

function* pageUpdatedHandler(action) {
  try {
    yield processPageUpdate(
      action.page,
      false,
      action.suppressThumb == true ? true : false,
    );

    // need to do something like (when we have something that does this like apply layout):
    // yield put(whileApplyingChanges(PageItems.updatePageItems(change.changes)))
  } catch (error) {
    console.error('pageUpdatedHandler error', error);
    // yield put({ type: 'USER_REFRESH_FAILED', error })
  }
}

/**
 * Called from updated changeset push to update local page info - updates multiple pages
 * @param action
 */
function* pagesUpdatedHandler(action) {
  try {
    const replace = action.replace == true;
    for (var i = 0; i < action.pages.length; ++i) {
      let page = action.pages[i];
      yield processPageUpdate(page, replace);
      // if (thumb == null || thumb == '') {
      //     //Need to generate a thumb.
      //     yield put(generateThumb(p.pageID, spread.id,sectionId));
      // }
    }

    const leftovers = action.leftovers;
    if (leftovers != undefined && leftovers.length > 0) {
      yield put(showLeftoverCaptionsModal(leftovers));
    }

    // need to do something like (when we have something that does this like apply layout):
    // yield put(whileApplyingChanges(PageItems.updatePageItems(change.changes)))
  } catch (error) {
    console.error('pagesUpdatedHandler error', error);
    // yield put({ type: 'USER_REFRESH_FAILED', error })
  }
}

function* processPageUpdate(page, replace, suppressThumb) {
  try {
    const projectPages = yield select(Selectors.pagesSelector);
    const projectPageItems = yield select(Selectors.pageItemsSelector);

    const oldPage = projectPages.get(page.id);
    if (!oldPage) {
      return;
    }

    const oldPageItemIDs = oldPage.get('pageItems').toJS();
    const newPageItemIDs = page.pageItems.map((pi) => pi.id);

    let updatedPageItems = [];
    let addedPageItems = [];
    let deletedPageItems = oldPageItemIDs.filter(
      (pi) => !newPageItemIDs.includes(pi),
    );

    let backgroundGI = undefined;

    // check all of the graphic items to see if any of them updated or are new
    if (
      page.background.hasOwnProperty('graphicItem') &&
      page.background.graphicItem != null
    ) {
      backgroundGI = page.background.graphicItem;
      let giID = backgroundGI.id;
      let newPI = fromJS(backgroundGI);

      if (projectPageItems.has(giID.id)) {
        if (!Immutable.is(projectPageItems.get(gi.id), newPI)) {
          updatedPageItems.push(fromJS(newPI));
        } else {
        }
      } else {
        newPI = newPI.set('pageID', page.id);
        addedPageItems.push(newPI);
      }

      page.background.graphicItem = giID;
    }

    for (let pi of page.pageItems) {
      let newPI = fromJS(pi);

      // first see if it is in the old page items
      if (projectPageItems.has(pi.id)) {
        if (!Immutable.is(projectPageItems.get(pi.id), newPI)) {
          updatedPageItems.push(newPI);
        } else {
        }
      } else {
        addedPageItems.push(newPI);
      }
    }

    const newPageItems = page.pageItems;
    // Update all pointers to page items
    page.pageItems = page.pageItems.map((pi) => pi.id);

    if (backgroundGI != undefined) {
      // page.background
      newPageItems.push(backgroundGI);
      page.background.graphicItem = backgroundGI.id;
    }

    if (addedPageItems.length > 0)
      yield put(whileApplyingChanges(insertPageItems(addedPageItems)));
    if (updatedPageItems.length > 0)
      yield put(whileApplyingChanges(updatePageItemsNoUndo(updatedPageItems)));

    //prevent noedits overlay from disappearing on page updates
    if (oldPage.get('belongsTo') != undefined) {
      page.belongsTo = oldPage.get('belongsTo');
    }

    if (replace) {
      yield put(
        whileApplyingChanges(replacePage(page, Immutable.fromJS(newPageItems))),
      );
    } else {
      yield put(whileApplyingChanges(updatePage(page)));
    }

    yield put(renderCanvasFromStore(page.id));
    if (!suppressThumb) yield Changesets.handleCreateThumbnail();
  } catch (error) {
    console.error('processPageUpdate error', error);
    // yield put({ type: 'USER_REFRESH_FAILED', error })
  }
}

function* mobileZoom(direction) {
  let nav = yield select(Selectors.navigationSelector);
  if (isMobile() && nav.zoomLevel !== PicabooConstants.ZOOM_LEVEL.FIT_PAGE) {
    let zoomPageLeft = nav.zoomPageLeft;
    if (
      (zoomPageLeft && direction === NEXT_SPREAD) ||
      (!zoomPageLeft && direction === PREVIOUS_SPREAD)
    ) {
      yield put(setLeftPageZoom(!zoomPageLeft));
      return true;
    }
  }

  return false;
}

function* loadSpreadHandler(action) {
  if (!action.keepSelection) {
    yield put(clearSelection());
  }

  let currentPages = yield select(Selectors.pagesSelector);
  let leftPage = currentPages.first();
  let rightPage = currentPages.last();
  let sections = yield select(Selectors.projectSectionsSelector);
  let projectMetadata = yield select(Selectors.projectMetadataSelector);
  let currentSection = (yield select(Selectors.sectionSelector)).toJS();
  let isPrints = yield select(Selectors.isPrints);
  let destinationSectionID = '';

  let currentSpreadIndex = 0;

  let data = null;
  let currentSectionIndex = 0;

  //this will have to change when we support multiple sections

  let sectionCounter = 0;

  sections.map((section) => {
    if (currentSection.sectionID === section.get('sectionID')) {
      section.get('spreads').map((spread, spreadIndex) => {
        const isCurrent = spread
          .get('pages')
          .toJS()
          .some((page) => {
            return (
              leftPage.get('id') === page.pageID ||
              rightPage.get('id') === page.pageID
            );
          });

        if (isCurrent) {
          //unfortunately, we can't use the currentSection here, as we need it's index.
          currentSpreadIndex = spreadIndex;
          currentSectionIndex = sectionCounter;
        }
      });
    }
    ++sectionCounter;
  });

  let spreadToLoad;
  let nextSpread;
  if (action.type === RELOAD_SPREAD || action.type === RELOAD_SPREAD_UNDOABLE) {
    data = 'header,sections';
    spreadToLoad = currentSpreadIndex;
    nextSpread = currentSection.spreads[spreadToLoad];
  } else if (action.type === GO_TO_SPREAD) {
    sections.some((section) => {
      let currentSection = section.toJS();
      for (let s in currentSection.spreads) {
        if (currentSection.spreads[s].id == action.spread) {
          destinationSectionID = currentSection.sectionID;
          spreadToLoad = s;
          break;
        }
      }
      if (spreadToLoad) {
        nextSpread = currentSection.spreads[spreadToLoad];
        if (nextSpread) {
          return true;
        }
      }
      return false;
    });
  } else {
    let showFrontEndleafMagicNumber = EnvUtils.isTrue(
      process.env.showFrontEndleaf,
    )
      ? 0
      : 1;
    if (action.type == NEXT_SPREAD) {
      let handled = yield mobileZoom(NEXT_SPREAD);
      if (handled) {
        return;
      }

      if (currentSpreadIndex + 1 >= currentSection.spreads.length) {
        let nextSectionIndex = currentSectionIndex + 1;
        if (sections.count() > nextSectionIndex) {
          let nextSection = sections.toList().toArray()[nextSectionIndex];
          // here the magic number is used to skip spread[0] if we're not showing front endleaf
          nextSpread = nextSection
            .get('spreads')
            .get(showFrontEndleafMagicNumber)
            .toJS();
          destinationSectionID = nextSection.get('sectionID');
        }
      } else {
        spreadToLoad = Math.min(
          currentSpreadIndex + 1,
          currentSection.spreads.length - 1,
        );
        nextSpread = currentSection.spreads[spreadToLoad];
      }
    } else {
      // this else must be action.type == PREVIOUS_SPREAD
      let handled = yield mobileZoom(PREVIOUS_SPREAD);
      if (handled) {
        return;
      }

      // and here the magic number is used again to skip spread[0] when we're not showing front endleaf
      if (currentSpreadIndex - 1 < showFrontEndleafMagicNumber) {
        let previousSectionIndex = currentSectionIndex - 1;
        if (previousSectionIndex >= 0) {
          let previousSection = sections.toList().toArray()[
            previousSectionIndex
          ];
          const previousSectionSpreads = previousSection.get('spreads');
          nextSpread = previousSectionSpreads
            .get(previousSectionSpreads.count() - 1)
            .toJS();
          destinationSectionID = previousSection.get('sectionID');
        }
      } else {
        spreadToLoad = Math.max(currentSpreadIndex - 1, 0);
        nextSpread = currentSection.spreads[spreadToLoad];
      }
    }

    if (nextSpread == undefined) {
      return;
    }
  }

  let project = null;
  let id;
  let projectPKOrShareID = {};
  let shareView = yield select(Selectors.shareViewSelector);
  if (nextSpread !== undefined) {
    let loadImages = false;
    if (shareView) {
      id = 'shareID';
    } else {
      id = 'projectPK';
    }
    projectPKOrShareID[id] = projectMetadata.get(id);
    project = yield getProject(
      projectPKOrShareID,
      data,
      null,
      null,
      nextSpread.id,
    );
    browserHistory.push(
      `${obfuscateProjectId(projectMetadata.get(id))}?s=${nextSpread.id}` +
        (getParameterByName('cid') ? '&cid=' + getParameterByName('cid') : '') +
        (getParameterByName('qty') ? '&qty=' + getParameterByName('qty') : ''),
    );

    if (loadImages) {
      yield put(setLoadedImagesSection(destinationSectionID));
    }
  }

  if (project === null) {
    console.error('No project.', action);
    return;
  }

  let images = yield select(Selectors.projectImagesSelector);
  let missing = [];

  if (project.imagesToCache) {
    for (let img of project.imagesToCache) {
      if (!images.get(img.id) && (!project.images || !project.images[img.id])) {
        missing.push(img.id);
      }
    }
  }

  //we need to fix layout fonts, a lot of them are set to "Microsoft Sans Serif"
  if (project.pageItems) {
    let validFontNames = yield select(Selectors.validFontSelector);
    Object.keys(project.pageItems).forEach((key) => {
      let pageItem = project.pageItems[key];
      if (pageItem.itemType === PicabooConstants.ITEM_TYPES.CAPTION) {
        if (!validFontNames.includes(pageItem.fontFamily)) {
          pageItem.fontFamily = 'Arial';
          project.pageItems[key] = pageItem;
        }
      } else if (
        pageItem.itemType === PicabooConstants.ITEM_TYPES.GRAPHICITEM &&
        pageItem.imageID
      ) {
        //Here we look for images used on the pages but not included in the section
        if (
          !images.get(pageItem.imageID) &&
          (!project.images || !project.images[pageItem.imageID])
        ) {
          missing.push(pageItem.imageID);
        }
      }
    });
  }

  if (missing.length > 0) {
    let imageData = yield getImagesMetadata(
      projectMetadata.get('projectPK'),
      missing,
    );

    //Add in these images to the project we just got back
    if (!project.images) {
      project.images = imageData.images;
    } else {
      for (let imageID of imageData.project.images) {
        let img = imageData.images[imageID];
        if (!img) {
          img = imageData.images[imageID.toLowerCase()];
        }
        if (img) {
          project.images[img.imageID] = img;
        } else {
          console.warn('metadata not found for imageID: ' + imageID);
        }
      }
    }

    if (!project.project.images || project.project.images.length === 0) {
      project.project.images = imageData.project.images;
    } else {
      for (let imageID of imageData.project.images) {
        if (imageData.images[imageID]) {
          project.project.images.push(imageID);
        }
      }
    }
  }

  if (action.type === RELOAD_SPREAD_UNDOABLE) {
    const msg = action.keepSelectedTab
      ? keepSelectedTab(setProjectUndoable(project))
      : setProjectUndoable(project);

    yield put(msg);
  } else {
    yield put(setProject(project));
    let newProjectMeta = yield select(Selectors.projectMetadataSelector);
    let pages = yield select(Selectors.pagesSelector);
    let sections = yield select(Selectors.projectSectionsSelector);
    let section = destinationSectionID
      ? sections.get(destinationSectionID).toJS()
      : currentSection;
    let pageId = getDefaultSelectedPage(newProjectMeta, pages, section);
    if (pageId) {
      yield put(selectPages([pageId]));
      let pageItemID = getDefaultSelectedPageItem(project, pageId);
      if (pageItemID) {
        yield put(selectPageItems([pageItemID]));
      }
    }
  }

  let nav = yield select(Selectors.navigationSelector);

  let zoomPageLeft = nav.zoomPageLeft;
  yield put(setLeftPageZoom(!zoomPageLeft));
  if (action.exitPreviewMode && action.exitPreviewMode == true)
    yield put(exitPreviewMode());

  yield put(renderCanvasFromStore());
  if (action.type == RELOAD_SPREAD_UNDOABLE || action.type == RELOAD_SPREAD) {
    const allPages = yield select(Selectors.projectPagesSelector);
    if (allPages.length == 1) {
      yield Changesets.handleCreateThumbnail();
    }
  }

  let applyLayoutCallBack = yield select(Selectors.applyLayoutCallBack);
  if (applyLayoutCallBack) {
    setTimeout(applyLayoutCallBack, 0); //allow state changes to propagate before executing callback
    yield put(setApplyLayoutCallback(null));
  }
}

function* generateThumbHandler(action) {
  const projectMetadata = yield select(Selectors.projectMetadataSelector);
  const isPrints =
    projectMetadata.get('type') === PicabooConstants.PRODUCT_TYPES.PRINTS;
  try {
    yield requestThumbnail(
      projectMetadata.get('projectPK'),
      action.spreadID,
      action.pageID,
      action.sectionID,
      action.isProjectThumb,
      action.cropCover,
      isPrints,
      action.isBlank,
      action.pageRatio,
    );
  } catch (e) {
    console.error('failed once', e);
    if (action.retryOnFail) {
      try {
        yield requestThumbnail(
          projectMetadata.get('projectPK'),
          action.spreadID,
          action.pageID,
          action.sectionID,
          action.isProjectThumb,
          action.cropCover,
          isPrints,
          action.isBlank,
          action.pageRatio,
        );
      } catch (e) {
        console.error('Errored twice, crud', action, e);
      }
    } else {
      console.error('Failed to generate thumbnail on server', action);
    }
  }
}

function isPageCoverThumb(pageID, section, projectType) {
  return projectType === PicabooConstants.PRODUCT_TYPES.BOOK
    ? section &&
        section.get('type') === PicabooConstants.SECTION_TYPES.TYPE_COVER &&
        section.getIn(['spreads', 0, 'pages', 0, 'pageID']) === pageID
    : section &&
        section.has('spreads') &&
        section.getIn(['spreads', 0, 'pages', 0, 'pageID']) === pageID;
}

function* generateThumbsHandler(action) {
  let outPage;
  yield put({ type: SET_GENERATE_THUMB_COUNT, count: action.pages.length });
  for (let i = 0; i < action.pages.length; ++i) {
    const page = action.pages[i];
    outPage = page;

    const project = yield select(Selectors.projectMetadataSelector);
    const sections = yield select(Selectors.projectSectionsSelector);

    const section = sections.get(page.sectionID);
    const wrap = yield select(wrapSelector);
    const isWrapped = wrap.get('showSpine');
    const isProjectThumb = isPageCoverThumb(
      page.pageID,
      section,
      project.get('type'),
    );
    const cropCover = isProjectThumb && isWrapped;
    yield put(
      generateThumb(
        page.pageID,
        page.spreadID,
        page.sectionID,
        isProjectThumb,
        true,
        cropCover,
        page.isBlank,
        page.pageRatio,
      ),
    );
  }
}

function* setupSagas() {
  yield takeEvery(REORDER_ITEM, reorderItemHandler);
  yield takeLatest(PAGE_UPDATED, pageUpdatedHandler);
  yield takeLatest(PAGES_UPDATED, pagesUpdatedHandler);
  yield takeLatest(
    [
      PREVIOUS_SPREAD,
      NEXT_SPREAD,
      GO_TO_SPREAD,
      RELOAD_SPREAD,
      RELOAD_SPREAD_UNDOABLE,
    ],
    loadSpreadHandler,
  );
  yield takeEvery(GENERATE_THUMB, generateThumbHandler);
  yield takeEvery(GENERATE_THUMBS, generateThumbsHandler);
  yield takeLatest(SPREADS_ADDED, spreadsAddedHandler);
  yield fork(watchThumbRequest);
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: reducer,
  saga: setupSagas, // doesn't have any sagas
};
